// extracted by mini-css-extract-plugin
export default {"iconClass":"styles_iconClass__FwPvi","text1":"styles_text1__M9KyP","text2":"styles_text2__8rSW3"};